<script lang="ts">
	interface Props {
		className?: string;
		strokeWidth?: number;
	}

	let { className = '', strokeWidth = 1.5 }: Props = $props();
</script>

<div class={className}>
	<svg
		version="1.1"
		id="Icons"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		viewBox="0 1 32 32"
		xml:space="preserve"
		stroke="currentColor"
		fill="none"
		stroke-width={strokeWidth}
	>
		<rect x="3" y="12" class="st0" width="26" height="10"></rect>
		<line class="st0" x1="6" y1="15" x2="10" y2="15"></line>
		<line class="st0" x1="8" y1="19" x2="8" y2="15"></line>
		<line class="st0" x1="11" y1="8" x2="15" y2="8"></line>
		<line class="st0" x1="11" y1="26" x2="15" y2="26"></line>
		<line class="st0" x1="13" y1="26" x2="13" y2="8"></line>
	</svg>
</div>
